module.exports = "<div ng-if=restrictUi.byUserType(restrictUi.userTypes.DEBUG) class=\"row ibox-content\" collapse=importScope.importSessionPanelIsCollapsed> <crud-import-session-select-filter></crud-import-session-select-filter> </div> <crud-import-session-compact-list ng-if=restrictUi.byUserType(restrictUi.userTypes.DEBUG)></crud-import-session-compact-list> <div ui-view></div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/sections/6-books/wrapper.html
// module id = 4123
// module chunks = 86